"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const DefaultIcon_1 = tslib_1.__importDefault(require("./DefaultIcon"));
exports.default = (props) => (React.createElement(DefaultIcon_1.default, Object.assign({}, props, { viewBox: "0 96 960 960" }),
    React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M200 856V756h160l120-360H320V296h400v100H580L460 756h140v100H200Z" })));
